import { useMutation } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const ADD_SPEC = gql`
  mutation AddSpec($input: CreateProductSpecificationInput!) {
    createProductSpecification(input: $input) {
      productVariantId
      name
      value
    }
  }
`;

export function useAddSpec<T>() {
  return useMutation<T>(ADD_SPEC);
}
